module.exports = __webpack_public_path__ + "img/u4.140e53d9.png";